import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FlexLayoutModule } from '@angular/flex-layout';

import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { Decorticage2Component } from './pages/decorticage2/decorticage2.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './pages/login/login.component';
import { OverviewComponent } from './pages/overview/overview.component';
import { CommandesComponent } from './pages/commandes/commandes.component';
import { DataService } from './data.service';
import { ListFactureComponent } from './pages/list-facture/list-facture.component';
import { ListDnComponent } from './pages/list-dn/list-dn.component';
import { DialogContentExampleDialog } from './components/dialog/dialogCreerElement/dialogCreerElement';
import { DialogContentNouveauDeco } from './components/dialog/dialogCreerDecorticage/dialogCreerDecorticage';
import { ListFormeComponent } from './components/list-forme/list-forme.component';
import { DevTestComponent } from './dev/dev-test/dev-test.component';
import { AppToolBarComponent } from './components/toolbar/app-tool-bar/app-tool-bar.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TabDecorticageComponent } from './components/tab-decorticage/tab-decorticage.component';

import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SelectLanguageComponent } from './components/select-language/select-language.component';
import { ListDecoComponent } from './pages/list-deco/list-deco.component';
import { ListCertificatsComponent } from './pages/list-certificats/list-certificats.component';
import { TabCertificateComponent } from './components/tab-certificate/tab-certificate.component';
import { CustomMatListComponent } from './components/custom-mat-list/custom-mat-list.component';
import { AlertDialogComponent, ConvertToTonne, CustomDateAdapter, CustomModalComponent, ShowOnlyNumberSupToZeroPipe, SplitePipe } from './classes/utilit';
import { SupervisorComponent } from './pages/supervisor/supervisor.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { QueryEditorComponent } from './pages/query-editor/query-editor.component';
import { PrintingListComponent } from './pages/printing-list/printing-list.component';
import { MaterialModulImport } from './material-module-import';
import { DialogImportComponent } from './components/dialog/dialogImport/dialogImport.component';
import { DialogErreurLineDecComponent } from './components/dialog/dialogErreurLineDec/dialogErreurLineDec.component';
import { DialogParamComponent } from './components/dialog/dialogParametre/param.component';
import { DialogShape99 } from './components/dialog/dialogShape99/dialogShape99';
import { SessionManagerPageComponent } from './pages/session-manager-page/session-manager-page.component';
import { ShapeComponent } from './pages/shape/shape.component';
import { ArmaShapeComponent } from './components/arma-shape/arma-shape.component';
import { EventObserverComponent } from './pages/event-observer/event-observer.component';
import { DialogHelp } from './components/dialog/dialogHelp/dialogHelp';
import { SiteSelectorComponent } from './components/site-selector/site-selector.component';
import { DateAdapter } from '@angular/material/core';
import { AjouterTicketComponent } from './pages/ariadis/ajouter-ticket/ajouter-ticket.component';
import { ArmaRepartitionComponent } from './components/arma-repartition/arma-repartition.component';
import { ArmaDateTimePickerComponent } from './components/arma-date-time-picker/arma-date-time-picker.component';
import { AngularResizedEventModule } from 'angular-resize-event';
import { SeeTicketComponent } from './pages/ariadis/see-ticket/see-ticket.component';
import { DialogProductInput } from './components/dialog/dialogProductInput/dialogProductInput';
import { FilterableInputComponent } from './components/filterable-input/filterable-input.component';
import { DialogSelectStr } from './components/dialog/dialogSelectStr/dialog-select-str';
import { DialogSpecialMesh } from './components/dialog/dialogSpecialMesh/dialogSpecialMesh';
import { SpliteDiamGradePipe } from './classes/decorticage/Utilits-analysis';
import { TraductionComponent } from './pages/traduction/traduction.component';
import { StockComponent } from './pages/stock/stock.component';
import localeFR from '@angular/common/locales/fr';
import localeEN_GB from '@angular/common/locales/en-GB';
import localeHE from '@angular/common/locales/he';
import { registerLocaleData } from '@angular/common';
import { DialogShapeSearch } from './components/dialog/dialogShapeSearch/dialogShapeSearch';
import { FilterComponentComponent } from './components/arma-filter-item/filter-component/filter-component.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {DialogContactComponent} from './components/dialog/dialogContact/dialog-contact.component';
import {DialogListContactComponent} from './components/dialog/dialogListContact/dialog-list-contact-component';
import { DialogOrderNoteComponent } from './components/dialog/dialog-order-note/dialog-order-note.component';
import routerPath from './classes/router-path';

// On charge le formattage pour les langues : Français, Anglais (UK), Hébreu
// Utilisé pour formater les nombres par exemple avec le pipe "| number:'1.3'", les dates etc...
registerLocaleData(localeHE);
registerLocaleData(localeFR);
registerLocaleData(localeEN_GB);

const ROUTES: Routes = [
  { path: '', redirectTo: routerPath.login, pathMatch: 'full' },
  //{ path: '**', component:  },
  { path: routerPath.login, component: LoginComponent },
  { path: routerPath.home, component: HomeComponent },
  { path: routerPath.overview, component: OverviewComponent },
  { path: routerPath.myOrders, component: CommandesComponent },
  { path: routerPath.decorticage, component: Decorticage2Component },
  { path: routerPath.decorticage_code, component: Decorticage2Component },
  { path: routerPath.siteFollowUp, component: ListDecoComponent },
  { path: routerPath.myDeliveryNote, component: ListDnComponent },
  { path: routerPath.myCertificats, component: ListCertificatsComponent },
  { path: routerPath.myCertificats_showBy, component: ListCertificatsComponent },
  { path: routerPath.myInvoice, component: ListFactureComponent },
  // Page employe
  { path: routerPath.dashboard_id, component: DashboardComponent },
  { path: routerPath.printingList, component: PrintingListComponent },
  { path: routerPath.supervisor, component: SupervisorComponent },
  { path: routerPath.eventObserver, component: EventObserverComponent },
  { path: routerPath.stock, component: StockComponent },
  // Page admin
  { path: routerPath.queryEditor, component: QueryEditorComponent },
  { path: routerPath.sessionManagment, component: SessionManagerPageComponent},
  // Sans connexion
  { path: routerPath.shapes, component: ShapeComponent},
  // Sans connexion - dédié à la gestion des ticket de support
  { path: routerPath.ticket, component: AjouterTicketComponent},
  { path: routerPath.ticket_numsociete, component: SeeTicketComponent},
  // Autre - Test
  { path: routerPath.translate, component: TraductionComponent },
  { path: routerPath.dev, component: DevTestComponent }
];

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    if (+(sessionStorage.getItem('dev') || '0') > 0)
      console.warn('Traduction manquante : (' + params.key + ')', params);
    return params.key;
  }
}

@NgModule({
  declarations: [
    AppComponent,
    Decorticage2Component,
    HomeComponent,
    DialogContentExampleDialog,
    DialogContentNouveauDeco,
    LoginComponent,
    OverviewComponent,
    CommandesComponent,
    ListFactureComponent,
    ListDnComponent,
    ListFormeComponent,
    DevTestComponent,
    AppToolBarComponent,
    TabDecorticageComponent,
    SelectLanguageComponent,
    ListDecoComponent,
    ListCertificatsComponent,
    TabCertificateComponent,
    CustomMatListComponent,
    SupervisorComponent,
    DashboardComponent,
    QueryEditorComponent,
    PrintingListComponent,
    DialogImportComponent,
    AlertDialogComponent,
    DialogErreurLineDecComponent,
    DialogSelectStr,
    DialogParamComponent,
    DialogShape99,
    DialogSpecialMesh,
    DialogHelp,
    CustomModalComponent,
    SessionManagerPageComponent,
    ShapeComponent,
    SplitePipe,
    SpliteDiamGradePipe,
    ConvertToTonne,
    ShowOnlyNumberSupToZeroPipe,
    ArmaShapeComponent,
    EventObserverComponent,
    SiteSelectorComponent,
    ArmaRepartitionComponent,
    AjouterTicketComponent,
    ArmaDateTimePickerComponent,
    SeeTicketComponent,
    DialogProductInput,
    FilterableInputComponent,
    TraductionComponent,
    StockComponent,
    DialogShapeSearch,
    FilterComponentComponent,
    DialogContactComponent,
    DialogListContactComponent,
    DialogOrderNoteComponent
  ],
  imports: [
    //BrowserModule.withServerTransition({appId: "serv-angular"}),
    BrowserModule,
    RouterModule.forRoot(ROUTES),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler
      },
      //useDefaultLang: false
    }),
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    ScrollingModule,
    MaterialModulImport,       // Pour importer les modules d'angular material
    AngularResizedEventModule,
    MatSlideToggleModule
  ],
  providers: [
    DataService,
    {provide: DateAdapter, useClass: CustomDateAdapter}, // Pour retourner le lundi comme jour par default
    /* On affecte LOCALE_ID à partir de la langue utilisée (anglais par défaut) pour formater correctement les nombres */
    {provide: LOCALE_ID, useValue: SelectLanguageComponent.getCurrentLocale().shortName },
    //{provide: MAT_DATE_LOCALE, useValue: SelectLanguageComponent.getCurrentLocale().shortName }
  ],
  bootstrap: [
    AppComponent
  ],
  entryComponents: [
    DialogContentExampleDialog,
    DialogContentNouveauDeco,
    DialogImportComponent,
    DialogParamComponent,
    DialogShape99,
    DialogSpecialMesh,
    DialogHelp,
    AlertDialogComponent,
    DialogErreurLineDecComponent,
    DialogSelectStr,
    CustomModalComponent,
    DialogProductInput,
    DialogShapeSearch,
    DialogOrderNoteComponent
  ]
})
export class AppModule { }

// required for AOT compilation
// Translate
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
